import React, { FC, PropsWithChildren, useCallback, useState } from 'react';
import { FormConfigContext, SaveFormOptions } from './formConfig.provider';
import { IFormDto } from 'src/services/api/api-client';
import { useGetFormsQuery } from 'src/services/api/api-client/FormsQuery';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useEditor } from '@craftjs/core';
import { EMPTY_LAYOUT } from '../uiEditor-helper';

export const FormConfigContextProvider: FC<PropsWithChildren<{ isInDesignerMode?: boolean }>> = (props) => {
  const study = useStudy();

  const { actions } = useEditor();
  const formConfigs = useGetFormsQuery({ studyId: study!.id }, { enabled: props.isInDesignerMode && !!study?.id });

  const [currentFormConfig, setCurrentFormConfig] = useState<IFormDto | null>(null);
  const [saveFormOptions, setSaveFormOptions] = useState<SaveFormOptions>({
    canBeSkipped: false,
    isMultiInstance: false,
    isPatientCreationForm: false,
    type: currentFormConfig?.type,
  });

  const setCurrentFormConfigHandler = useCallback(
    (newFormConfig: IFormDto | null) => {
      setCurrentFormConfig(newFormConfig);
      setSaveFormOptions({
        canBeSkipped: !!newFormConfig?.canBeSkipped,
        isMultiInstance: !!newFormConfig?.isMultiInstance,
        allowedForNotStartedPatients: !!newFormConfig?.allowedForNotStartedPatients,
        isPatientCreationForm: !!newFormConfig?.isPatientCreationForm,
        type: newFormConfig?.type ?? '',
      });

      actions.deserialize(JSON.stringify(newFormConfig?.layoutSchema ?? EMPTY_LAYOUT));
      actions.history.clear();
    },
    [actions],
  );

  return (
    <FormConfigContext.Provider
      value={{
        saveFormOptions,
        setSaveFormOptions,
        currentFormConfig,
        setCurrentFormConfig: setCurrentFormConfigHandler,
        formConfigs,
      }}
    >
      {props.children}
    </FormConfigContext.Provider>
  );
};
